import React from 'react';
import styled from 'styled-components';

function CardToolbar({start, end, ...props}) {
  if (!Array.isArray(start)) {
    start = [start];
  }

  if (!Array.isArray(end)) {
    end = [end];
  }

  return (
    <CardToolbarContainer {...props}>
      <CardToolbarSection>
        {start.map((item, i) => <CardToolbarItem key={i}>{item}</CardToolbarItem>)}
      </CardToolbarSection>
      <CardToolbarDivider />
      <CardToolbarSection>
        {end.map((item, i) => <CardToolbarItem key={i}>{item}</CardToolbarItem>)}
      </CardToolbarSection>
    </CardToolbarContainer>
  );
}

const CardToolbarContainer = styled.div`
  padding: 0.625rem 1.25rem;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  border-bottom: 0.0625rem solid #e4e4e4;
`;

const CardToolbarSection = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const CardToolbarItem = styled.div`
  margin: 0.625rem;
`;

const CardToolbarDivider = styled.div`
  flex: 1;
`;

export default CardToolbar;